import React from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Main from "./main/Main";
import i18n from '../components/utils/localization/i18n';
import {I18nextProvider} from "react-i18next";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />}/>
        </Routes>
      </BrowserRouter>
    </I18nextProvider>

  );
}

export default App;
